import { render, staticRenderFns } from "./bankDetails.vue?vue&type=template&id=0c885d4d&scoped=true"
import script from "./bankDetails.vue?vue&type=script&lang=js"
export * from "./bankDetails.vue?vue&type=script&lang=js"
import style0 from "./bankDetails.vue?vue&type=style&index=0&id=0c885d4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c885d4d",
  null
  
)

export default component.exports